import type { RbFragment } from '@/graphql/api'
import {
    type App,
    computed,
    type ComputedRef,
    inject,
    ref,
    type Ref,
} from 'vue'
import { cloneDeep } from '@/helpers/clone-deep.ts'

const key = 'app.plugin.ring_builder_data_store' as const

export function installRingBuilderDataStore(
    app: App,
    ringBuilderState: RbFragment | null | undefined
): RingBuilderDataStore {
    const store = createRingBuilderDataStore(ringBuilderState)

    app.provide(key, store)

    return store
}

function createRingBuilderDataStore(
    ringBuilderState: RbFragment | null | undefined
): RingBuilderDataStore {
    const state: Ref<RbFragment | null | undefined> = ref(ringBuilderState)

    return {
        state: computed(() => state.value),
        setState(newState: RbFragment | null | undefined) {
            state.value = cloneDeep(newState)
        },
    }
}

export interface RingBuilderDataStore {
    state: ComputedRef<RbFragment | null | undefined>

    setState(state: RbFragment | null | undefined): void
}

export function useRingBuilderDataStore(): RingBuilderDataStore {
    return inject(key) as RingBuilderDataStore
}
